module.exports = __webpack_public_path__ + "static/img/haowu.eaf55531.png";